<template>
  <div>
    <header style="display: none;">
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css">
      <!-- Include CSS do MDB -->
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/mdb-ui-kit/6.4.1/mdb.min.css">
    </header>


    <div class="row">
      <div class="m-3 col-md-12">
        <h5>Informações básicas</h5>
      </div>
      <div class="m-3 textarea-container">
        <label class="green-label" for="textareaId">Introdução:</label>
        <textarea id="textareaIntroducao" :value="listas.introducao" rows="3">{{ listas.introducao }}
          </textarea>
      </div>
      <div class="m-3 textarea-container">
        <label class="green-label" for="textareaId">Objetivo:</label>
        <textarea id="textareaObjetivo" :value="listas.objetivo" rows="3">{{ listas.objetivo }}
          </textarea>
      </div>
      <div class="m-3 textarea-container">
        <label class="green-label" for="textareaId">Premissas:</label>
        <textarea id="textareaPremissas" :value="listas.premissas" rows="3">{{ listas.premissas }}
          </textarea>
      </div>
      <div class="m-3 textarea-container mt-4">
        <label class="green-label" for="textareaId">Versão:</label>
        <input class="input-url" id="versao" :value="listas.versao" v-if="clone">
        <input class="input-url" id="versao" :value="listas.versao" v-if="this.clone === false" readonly>
      </div>

      <div class="m-3 col-md-12">
        <h5>URL Base</h5>
      </div>

      <div class="m-3 textarea-container mt-4">
        <label class="green-label" for="textareaId">URL Homologação - Principal:</label>
        <input class="input-url" id="urlHomologacaoPrincipal" :value="listas.urlAceiteW" v-if="clone">
        <input class="input-url" id="urlHomologacaoPrincipal" :value="listas.urlAceiteW" v-if="this.clone === false"
          readonly>
      </div>

      <div class="m-3 textarea-container">
        <label class="green-label" for="textareaId">URL Homologação - Secundário:</label>
        <input class="input-url" id="urlHomologacaoSecundario" :value="listas.urlAceiteY" v-if="clone">
        <input class="input-url" id="urlHomologacaoSecundario" :value="listas.urlAceiteY" v-if="this.clone === false"
          readonly>
      </div>

      <div class="m-3 textarea-container">
        <label class="green-label" for="textareaId">URL Produção:</label>
        <input class="input-url" id="urlProducao" :value="listas.urlProducao" v-if="clone">
        <input class="input-url" id="urlProducao" :value="listas.urlProducao" v-if="this.clone === false" readonly>
      </div>

      <div class="m-3 col-md-12">
        <h5>Credenciais</h5>
      </div>

      <div class="m-3 textarea-container">
        <label for="exampleSelect" class="green-label">Tipo de autenticação:</label>
        <select v-if="this.clone === false" @change="setarIcone()" class="form-select" id="tipoAutenticacao" disabled>
          <option v-if="listas.apiManager === 'N' && listas.tipoAutenticacao != 'C' && listas.tipoAutenticacao != 'H'"
            value="Selecione" selected>Selecione</option>
          <option v-if="listas.apiManager != 'N'">Selecione</option>

          <option v-if="listas.apiManager === 'N' && listas.tipoAutenticacao === 'C'" value="BODY" selected>BODY
          </option>
          <option v-if="listas.tipoAutenticacao != 'C' || listas.apiManager != 'N'" value="BODY">BODY</option>

          <option v-if="listas.apiManager === 'N' && listas.tipoAutenticacao === 'H'" value="HEADER" selected>HEADER
          </option>
          <option v-if="listas.tipoAutenticacao != 'H' || listas.apiManager != 'N'" value="HEADER">HEADER</option>

          <option v-if="listas.apiManager === 'A'" value="API MANAGER" selected>API MANAGER</option>
          <option v-if="listas.apiManager != 'A'" value="API MANAGER">API MANAGER</option>

          <option v-if="listas.apiManager === 'G'" value="API GESTÃO" selected>API GESTÃO</option>
          <option v-if="listas.apiManager != 'G'" value="API GESTÃO">API GESTÃO</option>
        </select>
        <select v-if="clone" @change="setarIcone()" class="form-select" id="tipoAutenticacao">
          <option v-if="listas.apiManager === 'N' && listas.tipoAutenticacao != 'C' && listas.tipoAutenticacao != 'H'"
            value="Selecione" selected>Selecione</option>
          <option>Selecione</option>

          <option v-if="listas.apiManager === 'N' && listas.tipoAutenticacao === 'C'" value="BODY" selected>BODY
          </option>
          <option v-if="listas.tipoAutenticacao != 'C' || listas.apiManager != 'N'" value="BODY">BODY</option>

          <option v-if="listas.apiManager === 'N' && listas.tipoAutenticacao === 'H'" value="HEADER" selected>HEADER
          </option>
          <option v-if="listas.tipoAutenticacao != 'H' || listas.apiManager != 'N'" value="HEADER">HEADER</option>

          <option v-if="listas.apiManager === 'A'" value="API MANAGER" selected>API MANAGER</option>
          <option v-if="listas.apiManager != 'A'" value="API MANAGER">API MANAGER</option>

          <option v-if="listas.apiManager === 'G'" value="API GESTÃO" selected>API GESTÃO</option>
          <option v-if="listas.apiManager != 'G'" value="API GESTÃO">API GESTÃO</option>
        </select>
      </div>

      <div v-if="clone" class="container mt-2 mb-3">
        <div @click="openModal(false)" style="display: none;" class="icon-container">
          <i @click="openModal(false)" class="fas fa-plus"></i>
        </div>
      </div>

      <div class="container m-3 mt-2 mb-3">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Parâmetro</th>
              <th scope="col">Formato</th>
              <th scope="col">Descrição</th>
              <th scope="col"> </th>
            </tr>
          </thead>

          <tbody v-if="listaAutenticacaoCatalogoApiModalAtualizado" model="selectedListasVendas"
            v-for="listaAutenticacao in listaAutenticacaoCatalogoApiModalAtualizado" :key="listaAutenticacao.campo"
            :value="listaAutenticacao.campo">
            <tr>
              <td style="width: 50px">
                {{ listaAutenticacao.campo }}
              </td>
              <td style="width: 1px">
                <span class="span-format" v-if="listaAutenticacao.formato === 'A'">Alfanumérico</span>
                <span class="span-format" v-if="listaAutenticacao.formato === 'N'">Numérico</span>
              </td>
              <td style="width: 269px">
                {{ listaAutenticacao.valor }}
              </td>
              <td class="icon-td" style="width: 104px">
                <button @click="openModal(listaAutenticacao)"
                  style="padding: 8px 13px 15px 13px;border: solid; border-color: #E8E8E8; border-width: 1px;"
                  class="btn btn-primary pen-icon">
                  <i @click="openModal(listaAutenticacao)" style="font-size: 14px !important;"
                    class="fa-solid fa-pen"></i>
                </button>

                <button
                  style="margin-left: 9px; padding: 8px 13px 15px 13px;border: solid; border-color: #E8E8E8; border-width: 1px;"
                  class="btn btn-primary trash-icon">
                  <i style="font-size: 13px !important;" class="fa-solid fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>

          <tbody v-if="!listaAutenticacaoCatalogoApiModalAtualizado" model="selectedListasVendas"
            v-for="listaAutenticacao in listaAutenticacaoCatalogoApi" :key="listaAutenticacao.campo"
            :value="listaAutenticacao.campo">
            <tr>
              <td style="width: 50px">
                {{ listaAutenticacao.campo }}
              </td>
              <td style="width: 1px">
                <span class="span-format" v-if="listaAutenticacao.formato === 'A'">Alfanumérico</span>
                <span class="span-format" v-if="listaAutenticacao.formato === 'N'">Numérico</span>
              </td>
              <td style="width: 269px">
                {{ listaAutenticacao.valor }}
              </td>
              <td class="icon-td" style="width: 104px">
                <button @click="openModal(listaAutenticacao)"
                  style="padding: 8px 13px 15px 13px;border: solid; border-color: #E8E8E8; border-width: 1px;"
                  class="btn btn-primary pen-icon">
                  <i @click="openModal(listaAutenticacao)" style="font-size: 14px !important;"
                    class="fa-solid fa-pen"></i>
                </button>

                <button
                  style="margin-left: 9px; padding: 8px 13px 15px 13px;border: solid; border-color: #E8E8E8; border-width: 1px;"
                  class="btn btn-primary trash-icon">
                  <i style="font-size: 13px !important;" class="fa-solid fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="m-3 mt-4" role="group" aria-label="Basic example">
        <div class="row">
          <div v-if="this.clone === false" class="col-8">
            <a href="/massificados/corporativo/gerenciador-parceiros-ui/#/consulta-catalogo">
              <button type="button" id="vendas" class="footer-button btn btn-primary btn-return"
                data-mdb-ripple-init>VOLTAR</button>
            </a>
          </div>
          <div v-if="clone" class="back-button col-6">
            <a href="/massificados/corporativo/gerenciador-parceiros-ui/#/consulta-catalogo">
              <button type="button" id="vendas" class="footer-button btn btn-primary btn-return"
                data-mdb-ripple-init>VOLTAR</button>
            </a>
          </div>
          <div v-if="clone" class="col-2">
            <button type="button" @click="$emit('confirmacao-publicar')" id="pos-venda"
              class="footer-button-active btn btn-primary active" data-mdb-ripple-init>PUBLICAR</button>
          </div>
          <div class="col-2 save-column">
            <button type="button" @click="salvarDados()" id="gestao-carteira"
              class="footer-button-active btn btn-primary active save-btn" data-mdb-ripple-init>SALVAR</button>
          </div>
        </div>
      </div>
    </div>



    <!-- O Modal -->
    <div v-if="showModal" class="modal fade" id="myModal" tabindex="-1" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" v-if="!listaAutenticacaoCatalogoApiModal" style="font-weight: 600;">Adicionar
              Parâmetro</h5>
            <h5 class="modal-title" v-if="listaAutenticacaoCatalogoApiModal" style="font-weight: 600;">Editar Parâmetro
            </h5>
            <button type="button" class="btn-close" data-mdb-dismiss="modal" @click="closeModal"
              aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="col-12 col-sm-12 col-md-3 m-3">
              <div class="form-outline">
                <input class="form-control active" style="display:none" id="nomeParametroBase"
                  v-if="!listaAutenticacaoCatalogoApiModal" :value="''">
                <input class="form-control active" style="display:none" id="nomeParametroBase"
                  v-if="listaAutenticacaoCatalogoApiModal" :value="listaAutenticacaoCatalogoApiModal.campo">

                <input class="form-control active" id="nomeParametro" v-if="!listaAutenticacaoCatalogoApiModal"
                  :value="''" required>
                <input class="form-control active" id="nomeParametro" v-if="listaAutenticacaoCatalogoApiModal"
                  :value="listaAutenticacaoCatalogoApiModal.campo">

                <label class="form-label green-label-color" for="">Nome do parâmetro:</label>
                <FormNotch />
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-6 m-3 mt-4">
              <div class="form-outline">
                <select v-if="this.clone === false" @change="setarIcone()" class="form-select" id="formato"
                  style="width: 100% !important;" disabled>
                  <option
                    v-if="listas.apiManager === 'N' && listas.tipoAutenticacao != 'C' && listas.tipoAutenticacao != 'H'"
                    value="Selecione" selected>Selecione</option>
                  <option v-if="listas.apiManager != 'N'">Selecione</option>

                  <option v-if="listas.apiManager === 'N' && listas.tipoAutenticacao === 'C'" value="BODY" selected>
                    BODY</option>
                  <option v-if="listas.tipoAutenticacao != 'C' || listas.apiManager != 'N'" value="BODY">BODY</option>

                  <option v-if="listas.apiManager === 'N' && listas.tipoAutenticacao === 'H'" value="HEADER" selected>
                    HEADER</option>
                  <option v-if="listas.tipoAutenticacao != 'H' || listas.apiManager != 'N'" value="HEADER">HEADER
                  </option>

                  <option v-if="listas.apiManager === 'A'" value="API MANAGER" selected>API MANAGER</option>
                  <option v-if="listas.apiManager != 'A'" value="API MANAGER">API MANAGER</option>

                  <option v-if="listas.apiManager === 'G'" value="API GESTÃO" selected>API GESTÃO</option>
                  <option v-if="listas.apiManager != 'G'" value="API GESTÃO">API GESTÃO</option>
                </select>
                <select v-if="clone" @change="setarIcone()" class="form-select" id="formato"
                  style="width: 100% !important;">
                  <option>Selecione</option>

                  <option v-if="listaAutenticacaoCatalogoApiModal.formato === 'A'" value="A" selected>Alfanumérico
                  </option>
                  <option v-if="listaAutenticacaoCatalogoApiModal.formato != 'A'" value="A">Alfanumérico</option>

                  <option v-if="listaAutenticacaoCatalogoApiModal.formato === 'N'" value="N" selected>Numérico</option>
                  <option v-if="listaAutenticacaoCatalogoApiModal.formato != 'N'" value="N">Numérico</option>
                </select>

                <input class="form-control active" style="display:none" id="formatoBase"
                  v-if="!listaAutenticacaoCatalogoApiModal" :value="''" required>
                <input class="form-control active" style="display:none" id="formatoBase"
                  v-if="listaAutenticacaoCatalogoApiModal.formato === 'A'" value='Alfanumérico'>
                <input class="form-control active" style="display:none" id="formatoBase"
                  v-if="listaAutenticacaoCatalogoApiModal.formato === 'N'" value='Numérico'>

                <label class="form-label green-label-color" for="">Formato:</label>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 m-3 mt-4">
              <div class="form-outline">
                <input class="form-control active" style="display:none" id="descricaoBase"
                  v-if="!listaAutenticacaoCatalogoApiModal" :value="''" required>
                <input class="form-control active" style="display:none" id="descricaoBase"
                  v-if="listaAutenticacaoCatalogoApiModal" :value="listaAutenticacaoCatalogoApiModal.valor">

                <input class="form-control active" id="descricao" v-if="!listaAutenticacaoCatalogoApiModal" :value="''"
                  required>
                <input class="form-control active" id="descricao" v-if="listaAutenticacaoCatalogoApiModal"
                  :value="listaAutenticacaoCatalogoApiModal.valor">

                <label class="form-label green-label-color" for="">Descrição:</label>
                <FormNotch />
              </div>
            </div>

          </div>

          <div class="m-3 mt-4" role="group" aria-label="Basic example">
            <div class="row m-1">
              <div class="col-5">
                <button @click="closeModal" type="button" id="vendas" class="footer-button btn btn-primary"
                  style="width: 105% !important;" data-mdb-ripple-init>CANCELAR</button>
              </div>
              <div class="col-1">
              </div>
              <div class="col-3">
                <button @click="editarDadosModal()" type="button" id="gestao-carteira"
                  style="width: 205% !important;color:white !important"
                  class="footer-button btn btn-primary active save-btn" data-mdb-ripple-init>SALVAR</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- O Modal Rest Soap -->
    <div v-if="showModal" class="modal modal-rest-soap fade" id="myModal" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="font-weight: 600;">Adicionar Menu</h5>
            <button type="button" class="btn-close" data-mdb-dismiss="modal" @click="closeModal"
              aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="col-12 col-sm-12 col-md-3 m-3">
              <div class="form-outline">
                <div class="textarea-container mt-5">
                  <label class="green-label" for="textareaId">Nome do menu:</label>
                  <input id="nomeMenu" class="input-modal" required>
                </div>
              </div>
            </div>
          </div>

          <div class="m-3 mt-4" role="group" aria-label="Basic example">
            <div class="row m-1">
              <div class="col-5">
                <button @click="closeModal" type="button" id="vendas" class="footer-button btn btn-primary"
                  style="width: 105% !important;" data-mdb-ripple-init>CANCELAR</button>
              </div>
              <div class="col-1">
              </div>
              <div class="col-3">
                <button @click="salvarNovoMenu()" type="button" id="gestao-carteira"
                  style="width: 205% !important;color:white !important"
                  class="footer-button btn btn-primary active save-btn" data-mdb-ripple-init>SALVAR</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- O Modal add item historico -->
    <div v-if="showModal" class="modal modal-add-itens-historico fade" id="myModal" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="font-weight: 600;">Adicionar item histórico</h5>
            <button type="button" class="btn-close" data-mdb-dismiss="modal" @click="closeModal"
              aria-label="Close"></button>
          </div>

          <div class="modal-body mb-4">
            <div class="col-12 col-sm-12 col-md-3 m-3">
              <div class="form-outline">
                <div class="textarea-container mt-4">
                  <label class="green-label" for="textareaId">Detalhe:</label>
                  <textarea rows="4" id="detalhe" class="input-modal text-area-historico" v-model="detalheNovoItem"
                    required></textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="m-3 mt-5" role="group" aria-label="Basic example">
            <div class="row m-1">
              <div class="col-5">
                <button @click="closeModal" type="button" id="vendas" class="footer-button btn btn-primary"
                  style="width: 105% !important;" data-mdb-ripple-init>CANCELAR</button>
              </div>
              <div class="col-1">
              </div>
              <div class="col-3">
                <button @click="salvarNovoItemHistorico()" type="button" id="gestao-carteira"
                  style="width: 205% !important;color:white !important"
                  class="footer-button btn btn-primary active save-btn" data-mdb-ripple-init>SALVAR</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="loader">
      <div>
        <div class="spinner-border"></div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import 'mdb-ui-kit';
import * as loaderUtils from '@/utils/loader';
import * as alertUtils from '@/utils/alert';
import FormNotch from './FormNotch.vue'

export default {
  name: 'Especificacoes',

  props: {
    clone: { type: Boolean, default: false },
    listas: { type: Object, default: () => ({}) },
    listaAutenticacaoCatalogoApi: { type: Array, default: () => [] }
  },

  data() {
    return {
      showModal: false,
      listaAutenticacaoCatalogoApiModal: null,
      listaAutenticacaoCatalogoApiModalAtualizado: null,
      idCatalogo: "",
      selectedListasVendas: "",
      selectedListasRestSoap: "",
      nomeCatalogo: "",
      showList: false,
      abaRest: false,
      abaSoap: false,
      listaMenuCatalogoApi: [],
      listaDadosRestSoap: [],
      listaDadoServicoMenu: [],
      listaItensHistorico: [],
      tipoNovoItem: "",
      detalheNovoItem: "",
      menuAtivo: "",
      itensHistorico: []
    };
  },

  components: {
    FormNotch
  },

  computed: {
    showPlusIcon() {
      if (!this.clone) return false;
      const tipo = this.getTipoAutenticacaoSelecionado();
      return tipo === 'BODY' || tipo === 'HEADER';
    }
  },

  mounted() {
    this.carregarGeral(this.$route.params.idCatalogo);

    this.setarIcone();
  },

  methods: {
    getTipoAutenticacaoSelecionado() {
      const el = document.getElementById('tipoAutenticacao');
      return el ? String(el.value || '') : '';
    },

    setarIcone() {
      const el = document.getElementById('tipoAutenticacao');
      const tipoCredencial = el ? el.value : 'Selecione';

      if (tipoCredencial !== "Selecione") $('.icon-container').css('display', 'flex');
      else $('.icon-container').css('display', 'none');
    },


    async openModal(data) {

      this.listaAutenticacaoCatalogoApiModal = data || { campo: '', formato: 'A', valor: '' }

      this.showModal = true;

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal');
          const modalInstance = new mdb.Modal(modalElement);
          await modalInstance.show();
        }, 200);
      } catch (error) {
        console.log(error);
      }
    },

    async closeModal() {
      this.showModal = false;

      $('.modal').hide();
      $('.modal-backdrop').hide();
      $('body').css('overflow', 'auto');
    },

    async editarDadosModal() {
      const formato = $('#formato').val();
      const descricao = $('#descricao').val();
      const nomeParametro = $('#nomeParametro').val();
      const nomeParametroBase = $('#nomeParametroBase').val();

      let atualizado = [];

      const fonte = (this.listaAutenticacaoCatalogoApiModalAtualizado && this.listaAutenticacaoCatalogoApiModalAtualizado.length)
        ? this.listaAutenticacaoCatalogoApiModalAtualizado
        : this.listaAutenticacaoCatalogoApi;

      fonte.forEach(item => {
        if (item.campo != nomeParametroBase) {
          atualizado.push(item);
        }
      });

      const bodyModal = {
        campo: nomeParametro,
        formato: formato.slice(0, 1),
        valor: descricao
      };

      atualizado.push(bodyModal);
      atualizado.reverse();

      this.listaAutenticacaoCatalogoApiModalAtualizado = atualizado;

      this.$emit('atualizar-autenticacao', atualizado);

      await this.closeModal();
    },



    async onActionInMenu() {
      document.querySelectorAll('.collapse.show').forEach(el => {
        const instance = mdb.Collapse.getOrCreateInstance(el);
        instance.hide();
      });

      $('i[id^="icon-"]').each(function () {
        $(this).removeClass('fa-angle-down').addClass('fa-angle-right');
      });
    },
    async onActionAtributeInComponent() {
      // Recarrega a página com a URL modificada
      location.reload();

      setTimeout(() => {
        $('#rest2').click();
      }, 2000);
    },
    async setandoMenuAtivo(nome) {
      $('#' + nome + '-content').css('display', 'block');

      this.pesquisar(nome.charAt(0).toUpperCase());

      if (nome === 'rest' || nome === 'soap') {
        await this.pesquisarDadosRestSoap(nome);

        $('div .back-button').removeClass('col-6');
        $('div .back-button').addClass('col-8');
        $('div .publish-button').removeClass('col-2');
        $('div .publish-button').addClass('col-3');
        $('.save-btn').css('display', 'none');
      } else if (nome === 'itens-historico') {
        $('#' + nome + '-content').css('display', 'block');

        $('div .back-button').removeClass('col-6');
        $('div .back-button').addClass('col-8');
        this.verificandoRestSoapMenu();

      } else {
        $('div .back-button').removeClass('col-8');
        $('div .back-button').addClass('col-6');

        $('.save-btn').css('display', 'unset');
      }

      if ('rest' != nome) {
        $('button#rest').removeClass('active');
        $('button#rest2').removeClass('active');
        $('button#rest3').removeClass('active');

        this.menuAtivo = 'S';

        $('#rest-content').css('display', 'none');
      }
      if (('soap' != nome) || this.clone === true) {
        $('button#soap').removeClass('active');
        $('button#soap2').removeClass('active');
        $('button#soap3').removeClass('active');

        this.menuAtivo = 'S';

        $('#soap-content').css('display', 'none');
      }
      if ('especificacoes' != nome) {
        $('button#especificacoes').removeClass('active');

        $('#especificacoes-content').css('display', 'none');
      }
      if ('itens-historico' != nome) {
        $('button#itens-historico').removeClass('active');

        $('#itens-historico-content').css('display', 'none');
      }

      this.verificandoRestSoapMenu();

      $('button#' + nome).addClass('active');
      $('button#' + nome + '2').addClass('active');
      $('button#' + nome + '3').addClass('active');
    },
    async salvarNovoItemHistorico() {
      const bodyData = {
        "tipo": this.tipoNovoItem,
        "detalhe": this.detalheNovoItem
      };

      const camposObrigatorios = new Array('detalhe', 'campo "detalhe" do item histórico');

      const erro = validadorUtils.validarCamposObrigatorios(bodyData, camposObrigatorios);

      if (erro) {
        return;
      }


      const urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/criar-item-historico/' + this.idCatalogo;
      const requestOptions = {
        method: 'POST',
        body: JSON.stringify(bodyData),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      };

      try {
        const response = await fetch(urlApi, requestOptions);

        if (response.ok) {
          alertUtils.alertSuccess("Item criado com sucesso!");
          this.pesquisar('V');
        } else {
          alertUtils.alertError("Erro ao criar item.");
        }
      } catch (error) {
        console.error('Erro ao salvar:', error);
        alertUtils.alertError('Erro ao salvar: ' + error.message);
      } finally {
        this.closeModalRestSoap();
      }
      setTimeout(() => {
        this.pesquisar('V');
        this.detalheNovoItem = "";
      }, 1000);

    },
    async salvarNovoMenu() {
      loaderUtils.addLoarder();

      const nomeMenu = $('#nomeMenu').val();

      // if(!nomeMenu) {
      //   alertUtils.alertError('É Obrigatório o preenchimento de todos os campos!', 'Fechar');
      //   return this.closeModalRestSoap();
      // } 


      let tipo = '';
      let nomeTipo = '';

      if (this.abaRest === true) {
        tipo = 'R';
        nomeTipo = 'rest';
      }

      if (this.abaSoap === true) {
        tipo = 'S';
        nomeTipo = 'soap';
      }

      const bodyData = {
        "codigo": this.ultimoCodigoMenu + 1,
        "tipo": tipo,
        "descricao": nomeMenu
      };
      const camposObrigatorios = new Array('descricao', 'campo "nome" do novo menu');

      const erro = validadorUtils.validarCamposObrigatorios(bodyData, camposObrigatorios);

      if (erro) {
        return;
      }

      let jsonRequest;

      const urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/incluir-menu-catalogo/' + tipo + '/' + this.idCatalogo;

      jsonRequest = JSON.stringify(bodyData);

      const requestAjax = await ajaxUtils.postOK(
        urlApi,
        jsonRequest,
        '',
        ''
      );

      this.pesquisarDadosRestSoap(nomeTipo);

      if (requestAjax) {
        alertUtils.alertSuccess("Menu criado com sucesso!");
      } else {
        alertUtils.alertError("Erro ao criar Menu!");
      }

      this.closeModalRestSoap();

      return requestAjax;
    },

    salvarDados() {
      const tipoAutenticacao = $('#tipoAutenticacao').val();
      const urlHomologacaoPrincipal = $('#urlHomologacaoPrincipal').val();
      const urlHomologacaoSecundario = $('#urlHomologacaoSecundario').val();
      const urlProducao = $('#urlProducao').val();
      const versao = $('#versao').val();

      const textareaIntroducao = $('#textareaIntroducao').val();
      const textareaObjetivo = $('#textareaObjetivo').val();
      const textareaPremissas = $('#textareaPremissas').val();

      const listaAutenticacaoCatalogoApi =
        (this.listaAutenticacaoCatalogoApiModalAtualizado && this.listaAutenticacaoCatalogoApiModalAtualizado.length)
          ? this.listaAutenticacaoCatalogoApiModalAtualizado
          : (Array.isArray(this.listaAutenticacaoCatalogoApi) ? this.listaAutenticacaoCatalogoApi : []);

      let apiManager = this.listas && this.listas.apiManager ? this.listas.apiManager : 'N';
      let updateTipoAutenticacao = this.listas && this.listas.tipoAutenticacao ? this.listas.tipoAutenticacao : null;

      switch (tipoAutenticacao) {
        case 'API MANAGER':
          apiManager = 'A';
          updateTipoAutenticacao = null;
          break;
        case 'API GESTÃO':
          apiManager = 'G';
          updateTipoAutenticacao = null;
          break;
        case 'BODY':
          apiManager = 'N';
          updateTipoAutenticacao = 'C';
          break;
        case 'HEADER':
          apiManager = 'N';
          updateTipoAutenticacao = 'H';
          break;
        default:
          // mantém os valores atuais do catálogo (não envia false)
          break;
      }

      const payload = {
        idCatalogoApi: String(this.listas && this.listas.idCatalogoApi ? this.listas.idCatalogoApi : ''),
        versao,
        introducao: textareaIntroducao,
        objetivo: textareaObjetivo,
        premissas: textareaPremissas,
        urlProducao,
        urlAceiteW: urlHomologacaoPrincipal,
        urlAceiteY: urlHomologacaoSecundario,
        apiManager,
        tipoAutenticacao: updateTipoAutenticacao,
        listaAutenticacaoCatalogoApi
      };

      this.$emit('salvar-dados', payload);
    },


    async openModalRestSoap() {
      this.showModal = true;

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal-rest-soap');
          const modalInstance = await new mdb.Modal(modalElement);

          await modalInstance.show();
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error)
      }
    },
    async openModalAddItemHistorico() {
      this.showModal = true;

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal-add-itens-historico');
          const modalInstance = await new mdb.Modal(modalElement);

          await modalInstance.show();
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error)
      }
    },


    async closeModalRestSoap() {
      this.showModal = false;

      $('.modal-rest-soap').hide();
      $('.modal-backdrop').hide();
      $('body').css('overflow', 'auto'); // Ativa a barra de rolagem
    },
    async verificandoRestSoapMenu() {
      this.abaRest = false;
      this.abaSoap = false;

      this.listaMenuCatalogoApi.forEach(menuCatalogo => {
        if (String(menuCatalogo.tipo) === 'R') {
          this.abaRest = true;
          // this.menuAtivo = 'R';
        }
        if (String(menuCatalogo.tipo) === 'S' || this.clone == true) {
          this.abaSoap = true;
          // this.menuAtivo = 'S';
        }
      });
      if (!this.abaRest) {
        $('#rest').attr('disabled', true);
        $('#rest2').attr('disabled', true);
        $('#rest3').attr('disabled', true);
        $('#rest4').attr('disabled', true);
      }
      if (!this.abaSoap) {
        $('#soap').attr('disabled', true);
        $('#soap2').attr('disabled', true);
        $('#soap3').attr('disabled', true);
        $('#soap4').attr('disabled', true);
      }

      const ultimoObjeto = this.listaMenuCatalogoApi[this.listaMenuCatalogoApi.length - 1];
      this.ultimoCodigoMenu = ultimoObjeto.codigo;
    },
    async clonarCatalogo(idCatalogo, grupo) {
      loaderUtils.addLoarder();

      let urlApi;
      let method;
      let requestOptions;

      urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/clonar/' + idCatalogo;
      method = 'GET';

      requestOptions = {
        method: method
      };

      try {
        fetch(urlApi, requestOptions)
          .then(async (response) => {
            if (response.ok) {
              let mensagem = (await response.text()).length === 12 ? "Catálogo já clonado!" : "Clone realizado com sucesso!";

              if (mensagem === "Catálogo já clonado!") {
                alertUtils.alertError(mensagem);
              } else {
                alertUtils.alertSuccess(mensagem);
              }

              this.pesquisar(String(grupo));

              return response.json();
            } else {
              throw new Error('Fechar');
            }
          })
          .then((data) => {
            loaderUtils.removeLoader();
          })
          .catch((error) => {
            loaderUtils.removeLoader();
            console.log(error)
          }).finally(() => loaderUtils.removeLoader());

      } catch (error) {
        console.error('Erro ao realizar busca:', error);
        alertUtils.alertError('Erro ao realizar busca:' + error);
      }
    },
    async deletarClone(idCatalogo, grupo) {
      loaderUtils.addLoarder();

      let urlApi;
      let method;
      let requestOptions;

      urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/deletar-clone/' + idCatalogo;
      method = 'POST';

      requestOptions = {
        method: method
      };

      try {
        fetch(urlApi, requestOptions)
          .then(async (response) => {
            if (response.ok) {
              alertUtils.alertSuccess("Catálogo clonado excluido!");

              this.pesquisar(String(grupo));

              return response.json();
            } else {
              throw new Error('Fechar');
            }
          })
          .then((data) => {
            loaderUtils.removeLoader();
          })
          .catch((error) => {
            console.log(error)
          }).finally(() => loaderUtils.removeLoader());

      } catch (error) {
        console.error('Erro ao realizar busca:', error);
        alertUtils.alertError('Erro ao realizar busca:' + error);
      }
    },
    async pesquisarServicoMenu(idCatalogo, codigoMenu, dadosRestSoap) {
      loaderUtils.addLoarder();

      let urlApi;
      let method;
      let requestOptions;

      urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/servicos/' + idCatalogo + '/' + codigoMenu;
      method = 'GET';

      requestOptions = {
        method: method
      };

      try {
        fetch(urlApi, requestOptions)
          .then(async (response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error('Fechar');
            }
          })
          .then(async (data) => {
            this.listaDadoServicoMenu = data;

            await this.agruparServicoMenu(dadosRestSoap);

            this.listaDadoServicoMenu = this.listaDadoServicoMenu.replace('[object Object],[object Object],[object Object],[object Object],[object Object],[object Object],[object Object]', '')

            loaderUtils.removeLoader();

            return data;
          })
          .catch((error) => {
            console.log(error)
          }).finally(() => loaderUtils.removeLoader());

      } catch (error) {
        console.error('Erro ao realizar busca:', error);
        alertUtils.alertError('Erro ao realizar busca:' + error);
      }
    },
    async agruparServicoMenu(dadosRestSoap) {
      let menuServicos = dadosRestSoap;

      for (let index = 0; index < menuServicos.length; index++) {
        menuServicos[index].servicos = this.listaDadoServicoMenu;
      }

      this.listaDadoServicoMenu += JSON.stringify(menuServicos);
    },
    async excluirItensHistorico(index) {
      const urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/apagar-item-historico/' + this.idCatalogo + '/' + index;
      const method = 'GET';

      const requestOptions = {
        method: method
      };

      try {
        const response = await fetch(urlApi, requestOptions);

        if (response.ok) {
          alertUtils.alertSuccess("Item excluído com sucesso!");
          await this.pesquisar('V'); // Atualiza os dados
          this.onActionInComponentHistorico();
        } else {
          alertUtils.alertError("Erro ao excluir item.");
        }
      } catch (error) {
        console.error('Erro ao excluir item:', error);
        alertUtils.alertError('Erro ao excluir item: ' + error.message);
      } finally {
        loaderUtils.removeLoader();
        this.closeModalRestSoap();
      }
      setTimeout(() => {
        this.pesquisar('V'); // atualiza o objeto 'listas'
      }, 1000);
    },

    async pesquisarDadosRestSoap(tipo) {
      loaderUtils.addLoarder();

      let urlApi;
      let method;
      let requestOptions;
      let tipoConvertido

      switch (tipo) {
        case 'rest':
          tipoConvertido = 'R';
          break;

        case 'soap':
          tipoConvertido = 'S';
          break;
      }

      urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/consulta-catalogo-menu/' + this.idCatalogo + '/' + tipoConvertido;
      method = 'GET';

      requestOptions = {
        method: method
      };

      try {
        fetch(urlApi, requestOptions)
          .then(async (response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error('Fechar');
            }
          })
          .then(async (data) => {
            this.showList = true;

            let dadosRestSoapMenu = data;

            // Atualizando listaDadosRestSoap de forma reativa
            this.listaDadosRestSoap = [...dadosRestSoapMenu]; // Substituindo o array com os novos dados

            for (let index = 0; index < dadosRestSoapMenu.length; index++) {
              await this.pesquisarServicoMenu(this.idCatalogo, dadosRestSoapMenu[index].codigo, dadosRestSoapMenu);
            }

            loaderUtils.removeLoader();
          })
          .catch((error) => {
            loaderUtils.removeLoader();
            console.log(error)
            alertUtils.alertError('Não encontramos nenhum resultado!', 'Fechar');
          }).finally(() => loaderUtils.removeLoader());

      } catch (error) {
        console.error('Erro ao realizar busca:', error);
        alertUtils.alertError('Erro ao realizar busca:' + error);
      }
    },
    async buscarNomeCatalogo() {
      let nomeCatalogo = this.listas.nome;

      console.log("nome catalogo? ", this.listas)
      if (nomeCatalogo) nomeCatalogo = nomeCatalogo.replace("-clone", " Clone");

      this.nomeCatalogo = nomeCatalogo;
    },
    async pesquisar(grupo) {
      loaderUtils.addLoarder();

      let urlApi;
      let method;
      let requestOptions;

      urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/consulta-catalogo/' + this.idCatalogo;
      method = 'GET';

      requestOptions = {
        method: method
      };

      try {
        fetch(urlApi, requestOptions)
          .then(async (response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error('Fechar');
            }
          })
          .then((data) => {
            this.showList = true;

            this.listaMenuCatalogoApi = (data && data.listaMenuCatalogoApi) ? data.listaMenuCatalogoApi : [];

            this.$emit('atualizar-listas', data || {});
            this.$emit('atualizar-autenticacao',
              (data && data.listaAutenticacaoCatalogoApi) ? data.listaAutenticacaoCatalogoApi : []
            );


            this.verificandoRestSoapMenu();
            this.buscarNomeCatalogo();
            //loaderUtils.removeLoader();
          })
          .catch((error) => {
            loaderUtils.removeLoader();
            console.log(error);
            alertUtils.alertError('Não encontramos nenhum resultado!', 'Fechar');
          }).finally(() => loaderUtils.removeLoader());

      } catch (error) {
        console.error('Erro ao realizar busca:', error);
        alertUtils.alertError('Erro ao realizar busca:' + error);
      }
    },
    async carregarGeral(idCatalogoAux) {
      this.idCatalogo = idCatalogoAux;



      this.pesquisar('V');

      setTimeout(() => {
        this.setarIcone();

        if (this.clone === 'false') $('td button').prop("disabled", true);

        if (this.clone === false) {
          $('.trash-icon').css("display", "none");
          $('.pen-icon').css("display", "none");
        }
      }, 1000); // 1000 milissegundos = 1 segundo
    }
  },
  watch: {
    listaAutenticacaoCatalogoApi: {
      immediate: true,
      handler(novaLista) {
        this.listaAutenticacaoCatalogoApiModalAtualizado = Array.isArray(novaLista)
          ? novaLista.slice()
          : [];
      }
    }
  }

};
</script>
<style scoped>
.loader {
  position: fixed;
  top: 0;
  left: 0;

  width: 100vw;
  height: 100vh;

  background: rgba(0, 0, 0, 0.65);

  display: flex;
  align-items: center;
  justify-content: center;
}

@import '/massificados/corporativo/gerenciador-parceiros-ui/portal-sistemas/css/manutencao/style.css';
</style>
